export enum CrossPrioritization {
  /** None */
  None = 0,
  /** Buy side is prioritized */
  BuySideIsPrioritized = 1,
  /** Sell side is prioritized */
  SellSideIsPrioritized = 2,
}
